import api from '@/lib/api';

export async function fetchCreativePartnerSetup() {
  const { data } = await api.get('/partners/creative/setup');
  return data;
}

export async function fetchMyCreativePartnerApplication() {
  const { data } = await api.get('/partners/creative/me');
  return data;
}

export async function submitCreativePartnerApplication(payload) {
  const { data } = await api.post('/partners/creative/apply', payload);
  return data;
}
